const handleNumericInput = (inputValue) => {
  const value = inputValue.replace(/[^0-9.]/g, '');
  return value;
};

export { handleNumericInput };
